import { render, staticRenderFns } from "./CollectionSidebar.vue?vue&type=template&id=dd8fb4d4&scoped=true&lang=pug&"
import script from "./CollectionSidebar.vue?vue&type=script&lang=js&"
export * from "./CollectionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSidebar.vue?vue&type=style&index=0&id=dd8fb4d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8fb4d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd8fb4d4')) {
      api.createRecord('dd8fb4d4', component.options)
    } else {
      api.reload('dd8fb4d4', component.options)
    }
    module.hot.accept("./CollectionSidebar.vue?vue&type=template&id=dd8fb4d4&scoped=true&lang=pug&", function () {
      api.rerender('dd8fb4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionSidebar.vue"
export default component.exports